import { setSpecificMessage, length } from "valibot";
setSpecificMessage(
  length,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);